import React from 'react'
import { useTranslation } from 'translations'
import { Section } from '../components/section'
import { PermissionToggle } from '../components/permissionToggle'
import { Permission } from 'settings/schema'

interface EngageToolPermissionsSectionProps {
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const EngageToolPermissionsSection = ({
    isAdminGranted,
    handlePermissionClick,
}: EngageToolPermissionsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Section title={t('settings.users.form.sections.engageTools')} className="engage-tool-permissions">
            <div className="row">
                <PermissionToggle
                    permission="view_wonderbar"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
                <PermissionToggle
                    permission="edit_wonderbar"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
            </div>
        </Section>
    )
}
